import React, { useEffect, useState, useRef } from "react";
import { compose } from "redux";

import actions from "fantastic/actions";
import setSelected from "fantastic/actions/setSelected";
import getSelected from "fantastic/selectors/getSelected";

import connectActions from "fantastic/lib/connectActions";
import connectProps from "fantastic/lib/connectProps";
import keyMap from "fantastic/lib/keyMap";

const IGNORE_TAGS = ["input", "select", "textarea"];

const HotKey = ({
  keyMap,
  selected,
  setSelected,
  undo,
  remove,
  versions: { currentIndex, sections }
}) => {
  const canUndo = sections[currentIndex - 1] !== undefined;
  const keySettings = { selected, setSelected, undo, canUndo, remove };

  const keyUpHandle = e => {
    if (e.keyCode === 17) window.fantasticCtrl = false;
  };

  const keyHandle = e => {
    if (e.keyCode === 17) window.fantasticCtrl = true;

    const { target } = e;
    if (target && target.tagName) {
      const tagName = target.tagName.toLowerCase();
      if (target.isContentEditable) return;
      if (IGNORE_TAGS.includes(tagName)) return;
    }

    const alreadySelected = keyMap(e, keySettings);
    if (alreadySelected) {
      window.addEventListener("keydown", keyHandle, { once: true });
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", keyHandle, { once: true });
    window.addEventListener("keyup", keyUpHandle);

    return () => {
      window.removeEventListener("keydown", keyHandle, { once: true });
      window.removeEventListener("keyup", keyUpHandle);
    };
  });

  return null;
};

export default compose(
  connectActions({
    setSelected,
    undo: actions.versionsUndo,
    remove: actions.removeId
  }),
  connectProps("versions", { selected: getSelected, keyMap: keyMap })
)(HotKey);
